<template>
  <BaseWidget
    :class="['company-profile', { incomplete: (companyMissingFields.length > 0) }]"
    :loading="loading"
    @refresh-data="refreshData" 
    @set-config="setConfig"
    v-on="$listeners"
  >
    <template v-slot:content>
      <div @click="widgetClick" class="company-profile-wrap">
        <template v-if="!loading && companyMissingFields.length > 0">
          <div class="incomplete-content-wrap">
            <div class="incomplete-content">
              <AnimationItem class="anim-warning" :animation="{ animationData: warningAnimation, loop: false }" :key="'anim_warning'" />
              <h3 class="mb-3">{{ $gettext('Company profile incomplete') }}</h3>
              <GekkoButton 
                v-if="progress < 100"
                @click="openWizard"
                :text="$gettext('Finish account setup')"
              />
            </div>
          </div>
        </template>
        <template v-if="!loading && companyMissingFields.length === 0">
          <!-- <AnimationItem class="anim-success" :animation="{ animationData: successAnimation, loop: false }" :key="'anim_success'" /> -->
          <div class="progress-wrap" @click="gotoSettings">
            <div>
              <img :src="currentCompany.logo" alt="" style="max-width: 100px; max-height: 100px;">
            </div>
            <h3>{{ currentCompany.name }}</h3>
            <div class="progress-wrap--hint">
              {{ currentCompany.address }} {{ currentCompany.city }}
            </div>
          </div>
        </template>
      </div>
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import BaseWidget from "@/components/dashboard/widgets/BaseWidget"
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'
import * as successAnimation from '@/css/animations/success.json';
import * as warningAnimation from '@/css/animations/warning.json';
import ImportKvkModal from "@/components/dashboard/ui/ImportKvkModal.vue";
import GekkoButton from '@/components/GekkoButton';
import DoughnutChart from '@/components/dashboard/charts/Doughnut'

export default {
  name: 'company-profile-widget',
  components: { 
    BaseWidget, 
    AnimationItem, 
    ImportKvkModal, 
    GekkoButton, 
    DoughnutChart 
  },
  props: {
    widget: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
      successAnimation: successAnimation.default,
      warningAnimation: warningAnimation.default,
      showImportKvkModal: false
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      companyMissingFields: 'main/getCompanyMissingFields',
      targetData: 'main/getCompanyRequiredData',
    }),
    progress () {
      return Math.round(((this.targetData.length - this.companyMissingFields.length) / this.targetData.length) * 100 )
    }
  },
  created () {

  },
  mounted () {
    this.setupWidget()
    this.setObjectStatus(this.widget.config)
  },
  methods: {
    ...mapActions({ 
      loadCurrentCompany: "main/loadCurrentCompany"
    }),
    ...mapMutations({ 
      openOnboardingWizard: 'onboarding/OPEN_ONBOARDING_WIZARD',
    }),
    setConfig (config) {
      if (config.status) this.setObjectStatus(config)
      this.$emit('save-config', this.config)
    },
    setObjectStatus (config) {
      if (config.status) {
        this.config.status = (config.status && config.status !== 'all') ? config.status : ''
      } 
      this.setFilters()
    },
    setFilters (status = false) {
      this.filters.status = (status) ? (status === 'all') ? '' : status : this.config.status
      this.refreshData()
    },
    refreshData () {
      this.getData()
    },
    updateFilters (status) {
      this.filters.status = (status === 'all') ? '' : status
      this.setFilters(status)
    },
    getData () {
      this.loading = true
      this.loadCurrentCompany().then(() => {
        this.loading = false
      })
    },
    setupWidget () {
      this.title = this.$gettext('Company profile')
    },
    removeWidget () {
      this.$emit('widget-event', { 'event': 'remove' })
      setTimeout(() => {
        this.$emit('widget-event', { 'event': 'update', 'target': 'activities-timeline-widget' })
      }, 100);
    },
    widgetClick () {
      if (!this.loading && this.companyMissingFields.length === 0) {
        this.gotoSettings()
      } else {
        this.openWizard()
      }
    },
    gotoSettings () {
      window.location.href = '/en/accounts/companies/'
    },
    openWizard () {
      this.openOnboardingWizard()
    }
  }
}
</script>

<style lang="scss">
.widget-wrapper.company-profile {
  cursor: pointer;
  &:not(.incomplete) {
    // border: 5px solid $colorBrand !important;
  }
  &.incomplete {
    border: 5px solid #ffcd1f !important;
  }
}

.company-profile {
  .company-profile-wrap {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
  }
  .progress-wrap {
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    line-height: 1.2;
    &--hint {
      font-size: 14px;
      color: #0000007d;
      margin-top: 5px;
    }
  }
  .incomplete-wrap {
    width: 100%;
    position: relative;
    font-size: 14px;
    .missing-list {
      list-style: none;
      margin: 0; margin-top: 10px;
      padding: 0;
      padding-left: 15px;
      li {
        padding-left: 20px;
        position: relative;
        &:before {
          content: '';
          width: 8px;
          height: 8px;
          border-radius: $radiusXl;
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translateY(-50%);
          background: $colorBrand;
        }
      }
    }
  }

  .incomplete-content-wrap {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1;
    .progress-count {
      font-size: 20px;
      font-family: DINNextLTPro-Medium, sans-serif;
      color: $colorAppInvoices;
      margin-bottom: 0.5rem;
      position: relative;
      .progress-number {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
      .donut-wrap {
        width: 75px;
        height: 75px;
      }
      // canvas {
      //   width: 75px;
      //   height: 75px;
      // }
    } 
    .incomplete-content { 
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: center;
      justify-content: flex-end;
      align-items: center;
      h4 { margin: 0; margin-bottom: 0.5rem; }
      p { display: none; font-size: 14px; color: $colorUnassigned; }
      .btn {  white-space: nowrap;}
    }

    @media (min-width: '992px') {
      flex-direction: row;
      .progress-count {
        font-size: 26px;
        font-family: DINNextLTPro-Medium, sans-serif;
      }
      .incomplete-content { 
        p { display: block; }
        padding-left: 0.25rem;
      }
    }

  }


  .anim-warning {
    width: 100px !important;
    height: 100px !important;
    margin: -1rem !important;
  }
  .anim-success {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .remove-widget-link {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
